import * as React from "react";
import { Bug, ShieldAlert, BugOff, Wind, Worm, House } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
const services = [{
  id: "ants",
  title: "Ant Control",
  description: "Comprehensive ant extermination and prevention for your home or business. Handle aggressive fire ants in North Fort Myers sandy soils.",
  image: "https://images.unsplash.com/photo-1581262177000-8139a463e531?auto=format&fit=crop&q=80&w=800",
  icon: Bug,
  link: "/PestControlPage"
}, {
  id: "termites",
  title: "North Fort Myers Termite Treatment",
  description: "Protect your property from destructive termites with our specialized treatments. Protect North Fort Myers homes from subterranean termites in high water table.",
  image: "https://images.unsplash.com/photo-1632750475125-07561328071c?auto=format&fit=crop&q=80&w=800",
  icon: ShieldAlert,
  link: "/TermiteTreatmentPage",
  featured: true
}, {
  id: "roaches",
  title: "Roach Extermination",
  description: "Fast and effective solutions to eliminate cockroach infestations completely.",
  image: "https://images.unsplash.com/photo-1626460204432-89244899f11c?auto=format&fit=crop&q=80&w=800",
  icon: BugOff,
  link: "/PestControlPage"
}, {
  id: "spiders",
  title: "Spider Control",
  description: "Keep your family safe from venomous and nuisance spiders indoors and out.",
  image: "https://images.unsplash.com/photo-1525833313571-271231056631?auto=format&fit=crop&q=80&w=800",
  icon: House,
  link: "/PestControlPage"
}, {
  id: "mosquitos",
  title: "Mosquito Control",
  description: "Reclaim your yard with our targeted mosquito reduction programs. Manage intense pressure from Caloosahatchee River and canal systems.",
  image: "https://images.unsplash.com/photo-1573591508233-1660fa487ff0?auto=format&fit=crop&q=80&w=800",
  icon: Wind,
  link: "/MosquitoControlPage"
}, {
  id: "millipedes",
  title: "Millipede Removal",
  description: "Stop millipede invasions in their tracks with perimeter defense treatments.",
  image: "https://images.unsplash.com/photo-1628595351029-c2bf17511435?auto=format&fit=crop&q=80&w=800",
  icon: Worm,
  link: "/PestControlPage"
}];
export default function NorthFortMyersPestServices() {
  return <section id="north-fort-myers-pest-services" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-12 md:mb-16">
          <Badge variant="secondary" className="mb-4">
            Local Expertise
          </Badge>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            North Fort Myers Pest Services
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl">
            Serving North Fort Myers Families with reliable, safe, and effective pest control solutions tailored to our unique Florida environment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div data-index={i} key={service.id} className="flex h-full">
                <Card className="flex flex-col w-full overflow-hidden border-border/50 hover:border-primary/50 transition-colors duration-300 shadow-sm hover:shadow-md">
                  <CardHeader className="p-0 relative">
                    <AspectRatio ratio={16 / 9}>
                      <img src={service.image} data-wvc-srcset={`${service.image}-wvc-srcset`} data-wvc-sizes={`${service.image}-wvc-sizes`} alt={service.title} className="object-cover w-full h-full" loading="lazy" />
                    </AspectRatio>
                    {service.featured && <div className="absolute top-4 right-4">
                        <Badge variant="default" className="shadow-sm">
                          Specialized Service
                        </Badge>
                      </div>}
                  </CardHeader>
                  <CardContent className="flex-grow p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="p-2 bg-primary/10 rounded-md text-primary">
                        <Icon className="w-5 h-5" />
                      </div>
                      <CardTitle className="font-default text-xl">
                        {service.title}
                      </CardTitle>
                    </div>
                    <CardDescription className="text-base">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="p-6 pt-0 mt-auto">
                    <Button asChild variant="outline" className="w-full group">
                      <Link to={service.link}>
                        Learn More
                        <span className="ml-2 group-hover:translate-x-1 transition-transform">
                          &rarr;
                        </span>
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}